import { useStore } from 'zustand';
import { useDatePickerContext } from './use-date-picker-context';
import { DatePickerStore } from '../types';

export const useDatePickerStore = <T>(selector: (store: DatePickerStore) => T) => {
  const { store } = useDatePickerContext();

  return useStore(store, selector);
};
